import { React, main, css, observer, useTranslation } from '../..';
import { TicketCardHeader } from '../../../detail/components/ticket-card/ticketCard';
import SubSection from './SubSection';

const OrderSummary = observer(() => {
    const { selectedCount, attendeesCount } = main;
    const { t } = useTranslation();

    return (
        <>
            <TicketCardHeader className={css['summary-header']}>
                <div className={css['summary-title']}>
                    <h3>{t('attendees.invitations.summary.title')}</h3>
                </div>
                <div className={css['summary-header-subsection']}>
                    <SubSection name={t('attendees.invitations.summary.rates')} content={selectedCount} />

                    <SubSection name={t('attendees.invitations.summary.attendees')} content={attendeesCount} />
                </div>
            </TicketCardHeader>
        </>
    );
});

export default OrderSummary;
